import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { IDeliverySettingsState, SLICE_NAME } from './models';

const deliverySettingsSelector = (state: RootState): IDeliverySettingsState => state[SLICE_NAME];

export const selectDeliverySettings = createSelector(
  deliverySettingsSelector,
  (state: IDeliverySettingsState) => state.settings,
);

export const selectDeliverySettingsIsLoading = createSelector(
  deliverySettingsSelector,
  (state: IDeliverySettingsState) => state.isLoading,
);

export const selectDeliverySettingsError = createSelector(
  deliverySettingsSelector,
  (state: IDeliverySettingsState) => state.error,
);
